import TopBar from "@/components/feature/TopBar";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";
import MobileCta from "@/components/feature/MobileCta";
import Hero from "./components/Hero";
import PositioningStrip from "./components/PositioningStrip";
import About from "./components/About";
import Philosophy from "./components/Philosophy";
import Treatments from "./components/Treatments";
import Pisom from "./components/Pisom";
import Journey from "./components/Journey";
import Experience from "./components/Experience";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import FinalCta from "./components/FinalCta";
import Instagram from "./components/Instagram";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <a
        href="#inicio"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-md focus:bg-accent-500 focus:px-4 focus:py-2 focus:text-sm focus:text-background-50"
      >
        Pular para o conteúdo
      </a>

      <div className="fixed inset-x-0 top-0 z-50">
        <TopBar />
        <Header />
      </div>

      <main>
        <Hero />
        <PositioningStrip />
        <About />
        <Philosophy />
        <Treatments />
        <Pisom />
        <Journey />
        <Experience />
        <Instagram />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>

      <Footer />
      <FloatingWhatsApp />
      <MobileCta />
    </div>
  );
}